// @ts-ignore: autogenerated import
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type LivestreamUpdateQueryVariables = Exact<{
	rowId: number;
	withVideoOnDemand: boolean;
}>;

export type LivestreamUpdateQuery = {
	moduleByRowId: {
		__typename: 'Module';
		rowId: number;
		livestream: {
			__typename: 'ModuleLivestream';
			start: string | null;
			end: string | null;
			hls: string | null;
			programme?: {
				__typename: 'MangoProgramme';
				videoFiles: {
					__typename: 'MangoVideoFileConnection';
					nodes: Array<{ __typename: 'MangoVideoFile'; publicLocation: string | null } | null> | null;
				} | null;
			} | null;
		} | null;
	} | null;
};

export const LivestreamUpdateDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'LivestreamUpdate' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'rowId' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'withVideoOnDemand' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'moduleByRowId' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'rowId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'rowId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'livestream' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'start' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'end' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hls' } },
											{
												kind: 'Field',
												alias: { kind: 'Name', value: 'programme' },
												name: { kind: 'Name', value: 'mangoProgramme' },
												directives: [
													{
														kind: 'Directive',
														name: { kind: 'Name', value: 'include' },
														arguments: [
															{
																kind: 'Argument',
																name: { kind: 'Name', value: 'if' },
																value: { kind: 'Variable', name: { kind: 'Name', value: 'withVideoOnDemand' } },
															},
														],
													},
												],
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'videoFiles' },
															arguments: [
																{
																	kind: 'Argument',
																	name: { kind: 'Name', value: 'filter' },
																	value: {
																		kind: 'ObjectValue',
																		fields: [
																			{
																				kind: 'ObjectField',
																				name: { kind: 'Name', value: 'videoProfile' },
																				value: {
																					kind: 'ObjectValue',
																					fields: [
																						{
																							kind: 'ObjectField',
																							name: { kind: 'Name', value: 'id' },
																							value: {
																								kind: 'ObjectValue',
																								fields: [
																									{
																										kind: 'ObjectField',
																										name: { kind: 'Name', value: 'eq' },
																										value: {
																											kind: 'StringValue',
																											value: 'av:http://ard.de/ontologies/audioVideo#VideoProfile_HLS',
																											block: false,
																										},
																									},
																								],
																							},
																						},
																					],
																				},
																			},
																		],
																	},
																},
															],
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'nodes' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publicLocation' } }],
																		},
																	},
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<LivestreamUpdateQuery, LivestreamUpdateQueryVariables>;
